module.exports = __webpack_public_path__ + "static/img/shi.37fb04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shi.png
// module id = KTvz
// module chunks = 1